import React, { useEffect, useState } from "react";
import ActivationSVG from "assets/images/fluent-emoji-high-contrast_ticket.svg";
import {
  createKit,
  messageClean,
  errorClean,
  createKitFile,
} from "redux-store/kit/kit.slice";
import {
  successMessage,
  addKitActivityInProcess,
  kitError,
  fileSuccessMessage,
} from "redux-store/kit/kit.selector";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import AddLinkIcon from "@mui/icons-material/AddLink";

const FirstSection = () => {
  const [kitCode, setKitCode] = useState({
    code: "",
  });
  const [kitLengthMessage, setKitMessage] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const activityInProgress = useSelector(addKitActivityInProcess);
  const sucessmessage = useSelector(successMessage);
  const errorMessage = useSelector(kitError);
  const fileMessage = useSelector(fileSuccessMessage);

  useEffect(() => {
    setKitMessage("");
    dispatch(errorClean());
    dispatch(messageClean());
  }, []);

  useEffect(() => {
    if (sucessmessage !== "") {
      setTimeout(function () {
        dispatch(messageClean());
      }, 5000);
    }
    // dispatch(errorClean());
  }, [sucessmessage]);

  const activatioCodeHandler = (e: any) => {
    let value = e.target.value;
    setKitCode({ ...kitCode, code: value });
  };

  const generateKit = () => {
    if (kitCode.code.length < 6 || kitCode.code.length > 6) {
      setKitMessage("Activation code should be 6 digits");
    } else {
      setKitMessage("");
      dispatch(createKit(kitCode));
    }
  };

  function handleCsvFile(event: any): void {
    const file = event.target.files[0];
    const allowedExtensions = /\.csv$/i;

    if (file) {
      if (!allowedExtensions.exec(file.name)) {
        alert("Invalid file type. Only CSV files are allowed.");
        // setSelectedFile(null); // Clear the selected file
      } else {
        const kits = new FormData();
        kits.append("kits", file);
        dispatch(createKitFile(kits));
        // Proceed with file handling or processing
      }
    }
  }
  return (
    <div className="tw-w-[80%] lg:tw-w-[90%] tw-mx-auto tw-py-6 lg:tw-py-12 tw-rounded-xl tw-bg-[#FFFFFF]">
      {/* main content */}
      <div className="tw-w-[80%] tw-mx-auto lg:tw-w-1/2 tw-flex tw-flex-col tw-gap-2 lg:tw-gap-8">
        {/*1st row  */}
        <div className=" tw-flex tw-items-center tw-gap-2 lg:tw-gap-5 ">
          <div className="tw-flex tw-items-center tw-justify-center tw-w-[2.1875rem]  lg:tw-w-[4.75rem]  tw-rounded-[50%]  tw-p-1 lg:tw-p-3 tw-bg-reddishOrange">
            <img className="" src={ActivationSVG} alt="activation" />
          </div>
          <div>
            <p className="tw-font-bold tw-text-[1rem] lg:tw-text-2xl">
              Activation Code
            </p>
            {/* {data[0]} */}
            <p className="tw-text-[0.75rem] lg:tw-text-[1.25rem] ">
              Enter Test Kit Activation Code to add in the list
            </p>
          </div>
        </div>
        {/*2nd row  */}
        <div className="tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-center tw-gap-5 tw-justify-start ">
          <div className="tw-hidden tw-w-[4.75rem] lg:tw-flex lg:tw-items-center lg:tw-justify-center  lg:tw-rounded-full tw-p-2 lg:tw-p-5 tw-text-[0.75rem] md:tw-flex"></div>
          <div className="tw-flex tw-gap-2 tw-items-center tw-my-2">
            <label>
              <input
                type="file"
                className="file-input tw-hidden"
                onChange={handleCsvFile}
                // accept=".csv"
              />
              <AddLinkIcon className=" tw-rotate-90" fontSize="large" />
            </label>
            <input
              className="tw-w-full lg:tw-w-full tw-p-1 lg:tw-p-3 tw-border-[0.0625rem] lg:tw-border-[0.1875rem] tw-border-solid tw-border-black focus:tw-outline-none"
              type="number"
              onChange={activatioCodeHandler}
            />
          </div>
          <button
            className="tw-w-fit tw-mx-auto tw-py-2 lg:tw-py-4 tw-px-8 lg:tw-px-14 lg:tw-ml-14  tw-bg-reddishOrange  tw-flex tw-items-center tw-justify-center tw-text-[0.75rem] lg:tw-text-[1.125rem] tw-font-bold tw-text-white tw-rounded-[0.625rem]"
            onClick={generateKit}
          >
            {activityInProgress ? "Adding..." : "Add"}
          </button>
        </div>
        <span
          className={`tw-text-sm tw-mx-24 ${
            kitLengthMessage === "" && errorMessage.message === ""
              ? "tw-text-green-600"
              : "tw-text-red-600"
          }`}
        >
          {kitLengthMessage !== ""
            ? kitLengthMessage
            : errorMessage.message !== ""
            ? errorMessage.message
            : sucessmessage === "Kit created successfully" ||
              fileMessage === "kits created successfully"
            ? sucessmessage || fileMessage
            : ""}
        </span>
        <span className={"tw-text-green-600"}>
          {fileMessage === "kits created successfully" ? fileMessage : ""}
        </span>
      </div>
    </div>
  );
};

export default FirstSection;
